import { render, staticRenderFns } from "./FavouriteScanModal.vue?vue&type=template&id=2f96dd5a&scoped=true"
import script from "./FavouriteScanModal.vue?vue&type=script&lang=js"
export * from "./FavouriteScanModal.vue?vue&type=script&lang=js"
import style0 from "./FavouriteScanModal.vue?vue&type=style&index=0&id=2f96dd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96dd5a",
  null
  
)

export default component.exports